var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailsList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 4.75H7a.75.75 0 0 1 0-1.5h15a.75.75 0 0 1 0 1.5zM16 9.75H7a.75.75 0 0 1 0-1.5h9a.75.75 0 0 1 0 1.5zM22 15.75H7a.75.75 0 0 1 0-1.5h15a.75.75 0 0 1 0 1.5zM16 20.75H7a.75.75 0 0 1 0-1.5h9a.75.75 0 0 1 0 1.5z",
    fill: "#2b7f75",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 4,
    r: 1.25,
    fill: "#2b7f75",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 9,
    r: 1.25,
    fill: "#2b7f75",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 15,
    r: 1.25,
    fill: "#2b7f75",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 20,
    r: 1.25,
    fill: "#2b7f75",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsList);
export default __webpack_public_path__ + "static/media/details-list.1b168ff79b6dda067f5dda63ed4a9632.svg";
export { ForwardRef as ReactComponent };